import { html } from "lit";

const strings = {
  loading: "", // Default is no loading content
};

export const _loading = () => {
  return html`<p class="beam-loading">${strings.loading}</p>`;
};
